export default __webpack_public_path__ + "static/media/chop-header-logo.b7b8a856.png";